import React from "react";
import InfoCircleIcon from "../icons/info-circle.icon";
import styles from "./alert-line.module.scss";

export const AlertLine = ({ message }) => {
  return (
    <div
      role="alert"
      className={styles.alertLine}
      aria-live="polite"
    >
      <div className={styles.iconContainer}>
        <InfoCircleIcon className={styles.icon} />
      </div>

      <div className={styles.contentContainer}>
        <p className={styles.text}>
          {message}
        </p>
      </div>
    </div>
  );
};